export default {
  data: {
    eventStatus: {
      0: "Черновик",
      1: "На модерации",
      2: "Опубликовано",
      3: "Отклонено",
      4: "Отменено",
    },
    eventRegistrationWindowStatus: {
      "-1": "Регистрация: неизвестно",
      0: "Регистрация скоро",
      1: "Регистрация открыта",
      2: "Регистрация закрыта",
    },
    eventScheduleStatus: {
      "-1": "Статус события: неизвестно",
      0: "Скоро",
      1: "Идёт сейчас",
      2: "Завершено",
    },
    depositWorkCategory: {
      0: "Категория 0",
      1: "Категория 1",
      2: "Категория 2",
      3: "Категория 3",
      4: "Категория 4",
      5: "Категория 5",
      6: "Категория 6",
      7: "Категория 7",
      8: "Категория 8",
      9: "Категория 9",
      10: "Категория 10",
      11: "Категория 11",
      12: "Категория 12",
      13: "Категория 13",
      14: "Категория 14",
      15: "Категория 15",
      16: "Категория 16",
      17: "Категория 17",
      18: "Категория 18",
      19: "Категория 19",
    },
    depositIndustryDirection: {
      0: "Индустрии текста и смыслов",
      1: "Индустрии визуального образа",
      2: "Музыкальные и звуковые индустрии",
      3: "Сценические и перформативные индустрии",
      4: "Цифровые и интерактивные индустрии",
      5: "Экранные и аудиовизуальные индустрии",
      6: "Пространственные и объектные индустрии",
    },
    depositWorkCategoryMember: {
      LiteraryWork: "Литературное произведение",
      DramaScript: "Драматургия, сценарий",
      MusicalWork: "Музыкальное произведение",
      PhonogramRecording: "Фонограмма",
      AudiovisualWork: "Аудиовизуальное произведение",
      FineArt: "Изобразительное искусство",
      Handicraft: "Ремесло, декоративно-прикладное искусство",
      PhotographyIllustration: "Фотография, иллюстрация",
      DesignLogo: "Дизайн, логотип",
      ArchitectureBlueprintPrototype: "Архитектура, чертёж, макет",
      ChoreographyDance: "Хореография, танец",
      DigitalService: "Цифровой сервис",
      OnlineCourseEducationalMaterial: "Онлайн-курс, учебные материалы",
      ScientificWork: "Научная работа",
      ComputerGraphics3d: "Компьютерная графика, 3D",
      GameGameDesign: "Игра, геймдизайн",
      Database: "База данных",
      CompositeCollection: "Составное произведение, сборник",
      DerivativeWork: "Производное произведение",
      Other: "Иное",
    },
    depositIndustryDirectionMember: {
      TextAndMeaningIndustries: "Индустрии текста и смыслов",
      VisualImageIndustries: "Индустрии визуального образа",
      AudioAndSoundIndustries: "Музыкальные и звуковые индустрии",
      PerformingArtsIndustries: "Сценические и перформативные индустрии",
      DigitalInteractiveIndustries: "Цифровые и интерактивные индустрии",
      ScienceAndEducationIndustries: "Экранные и аудиовизуальные индустрии",
      CraftAndAppliedArtsIndustries: "Пространственные и объектные индустрии",
    },
    depositRecordStatus: {
      "-1": "Черновик",
      0: "Черновик",
      1: "Подготовка к подаче",
      2: "На модерации",
      3: "Подтверждено",
      4: "Отклонено",
      5: "Согласование с командой",
      6: "Требует правок",
    },
    depositRightsHolderKind: {
      0: "Физическое лицо",
      1: "Организация",
    },
    depositAuthorRole: {
      0: "Автор",
      1: "Соавтор",
    },
  },
}
